var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_1881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37266 0 0 5.37266 0 12C0 18.6273 5.37266 24 12 24C18.6273 24 24 18.6273 24 12C23.9926 5.37578 18.6242 0.0074219 12 0ZM12 23.2C5.81445 23.2 0.8 18.1855 0.8 12C0.8 5.81445 5.81445 0.8 12 0.8C18.1855 0.8 23.2 5.81445 23.2 12C23.193 18.1826 18.1826 23.193 12 23.2Z",
    fill: "#1D1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1998 4.80005H6.7998C5.6957 4.80142 4.80117 5.69595 4.7998 6.80005V17.2C4.80117 18.3041 5.6957 19.1987 6.7998 19.2H17.1998C18.3039 19.1987 19.1984 18.3041 19.1998 17.2V6.80005C19.1984 5.69595 18.3039 4.80142 17.1998 4.80005ZM18.3998 17.2C18.3998 17.8627 17.8625 18.4 17.1998 18.4H6.7998C6.13711 18.4 5.5998 17.8627 5.5998 17.2V6.80005C5.5998 6.13735 6.13711 5.60005 6.7998 5.60005H17.1998C17.8625 5.60005 18.3998 6.13735 18.3998 6.80005V17.2Z",
    fill: "#1D1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8C9.79082 8 8 9.79082 8 12C8 14.2092 9.79082 16 12 16C14.2092 16 16 14.2092 16 12C15.9977 9.7918 14.2082 8.00234 12 8ZM12 15.2C10.2326 15.2 8.8 13.7674 8.8 12C8.8 10.2326 10.2326 8.8 12 8.8C13.7674 8.8 15.2 10.2326 15.2 12C15.198 13.7664 13.7664 15.198 12 15.2Z",
    fill: "#1D1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4002 6.3999C15.7375 6.3999 15.2002 6.93721 15.2002 7.5999C15.2002 8.2626 15.7375 8.7999 16.4002 8.7999C17.0629 8.7999 17.6002 8.2626 17.6002 7.5999C17.6002 6.93721 17.0629 6.3999 16.4002 6.3999ZM16.4002 7.9999C16.1793 7.9999 16.0002 7.8208 16.0002 7.5999C16.0002 7.379 16.1793 7.1999 16.4002 7.1999C16.6211 7.1999 16.8002 7.379 16.8002 7.5999C16.8002 7.8208 16.6211 7.9999 16.4002 7.9999Z",
    fill: "#1D1B1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_1881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.ef11c3d0a931f3e6ace46a5f3c084710.svg";
export { ForwardRef as ReactComponent };